import { IDeveloperStyleOverrides } from 'dromo-uploader-react'
import useTheme from '@mui/material/styles/useTheme'

export function useStyleOverrides(): IDeveloperStyleOverrides {
  const theme = useTheme()

  return {
    global: {
      textColor: '#888',
      customFontURL:
        'https://fonts.googleapis.com/css2?family=Roboto&display=swap',
      customFontFamily: "'Roboto', sans-serif",
    },
    primaryButton: {
      borderRadius: '0.25rem',
      backgroundColor: theme.palette.primary.main,
      textColor: '#ffffff',
      hoverBackgroundColor: theme.palette.primary.main,
      hoverTextColor: '#ffffff',
    },
    secondaryButton: {
      borderRadius: '0.25rem',
      backgroundColor: '#ffffff',
      border: `1px solid ${theme.palette.primary.main}`,
      textColor: theme.palette.primary.main,
      hoverBackgroundColor: '#ffffff',
      hoverTextColor: theme.palette.primary.main,
    },
    stepperBar: {
      currentColor: theme.palette.primary.main,
    },
  }
}
